export default __webpack_public_path__ + "static/media/pexels-richa-sharma-4217311.bb918a61.jpg";